import { render, staticRenderFns } from "./RadialGraphClockwise.vue?vue&type=template&id=19a05bf1"
import script from "./RadialGraphClockwise.vue?vue&type=script&lang=js"
export * from "./RadialGraphClockwise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports